import axios from 'axios'

const apiUrl = 'https://sitebypro-server.ru/druzbamebel'

const EQUIPMENT_CACHE_KEY = 'druzhba_equipment_cache_v1'

function readEquipmentCache() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(EQUIPMENT_CACHE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (_) { return [] }
}

function writeEquipmentCache(products) {
  try {
    if (Array.isArray(products) && products.length) window.localStorage.setItem(EQUIPMENT_CACHE_KEY, JSON.stringify(products))
  } catch (_) {}
}

export default {
  state: {
    equipment: [],
    siteSettings: {
      promo_lines: [
        'Диваны напрямую от фабрики — выгода до 30%',
        'Изготовление по вашим размерам и ткани',
        'Доставка диванов по России',
        'Поможем подобрать диван для ежедневного сна'
      ]
    }
  },
  getters: {
    equipment(state) {
      return state.equipment
    },
    siteSettings(state) {
      return state.siteSettings
    },
    promoLines(state) {
      return Array.isArray(state.siteSettings.promo_lines) ? state.siteSettings.promo_lines : []
    }
  },
  mutations: {
    SET_EQUIPMENT(state, data) {
      state.equipment = Array.isArray(data) ? data : []
    },
    SET_SITE_SETTINGS(state, data) {
      state.siteSettings = data && typeof data === 'object' ? data : state.siteSettings
    }
  },
  actions: {
    async GET_REVIEWS(context, data) {
      try {
        const response = await axios.post(`${apiUrl}/equipment/get-reviews`, data)
        return Array.isArray(response?.data?.data) ? response.data.data : []
      } catch (error) {
        console.warn('Не удалось загрузить отзывы', error)
        return []
      }
    },
    async GET_ALL_REVIEWS() {
      try {
        const response = await axios.get(`${apiUrl}/equipment/get-all-reviews`)
        return Array.isArray(response?.data?.data) ? response.data.data : []
      } catch (error) {
        console.warn('Не удалось загрузить все отзывы', error)
        return []
      }
    },
    async ADD_REVIEW(context, data) {
      const response = await axios.post(`${apiUrl}/equipment/add-review`, data)
      if (String(response?.data?.status) !== '200') {
        throw new Error(response?.data?.data?.text || 'Не удалось отправить отзыв')
      }
      return response.data.data
    },
    async GET_SITE_SETTINGS({ commit }) {
      try {
        const response = await axios.get(`${apiUrl}/equipment/get-site-settings`)
        if (response?.data?.data) commit('SET_SITE_SETTINGS', response.data.data)
        return response?.data?.data || {}
      } catch (error) {
        console.warn('Не удалось загрузить настройки сайта', error)
        return {}
      }
    },
    async UPDATE_SITE_SETTINGS({ commit }, data) {
      const response = await axios.post(`${apiUrl}/equipment/admin/update-site-settings`, data)
      if (String(response?.data?.status) !== '200') {
        throw new Error(response?.data?.data?.text || 'Не удалось сохранить настройки')
      }
      commit('SET_SITE_SETTINGS', data)
      return response.data.data
    },
    async GET_EQUIPMENT({ commit }) {
      try {
        const response = await axios.get(`${apiUrl}/equipment/get-equipment`)
        const products = response?.data?.data
        if (Array.isArray(products) && products.length) { writeEquipmentCache(products); commit('SET_EQUIPMENT', products) } else commit('SET_EQUIPMENT', readEquipmentCache())
      } catch (error) {
        console.warn('Не удалось загрузить каталог, используется локальный резерв', error)
        commit('SET_EQUIPMENT', readEquipmentCache())
      }
    }
  }
}
